"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var zilliqa_1 = require("@zilliqa-js/zilliqa");

var crypto_1 = require("@zilliqa-js/crypto");

var namehash_1 = __importDefault(require("./zns/namehash"));

var lodash_1 = __importDefault(require("lodash"));

var DefaultSource = 'https://api.zilliqa.com/';
var registryAddress = 'zil1jcgu2wlx6xejqk9jw3aaankw6lsjzeunx2j0jz';
var NullAddress = '0x0000000000000000000000000000000000000000';

var default_1 =
/** @class */
function () {
  function default_1(source) {
    if (source === void 0) {
      source = DefaultSource;
    }

    if (source == true) {
      source = DefaultSource;
    }

    source = source.toString();
    this.zilliqa = new zilliqa_1.Zilliqa(source);
    this.registry = this.zilliqa.contracts.at(registryAddress);
  }

  default_1.prototype.getContractField = function (contract, field) {
    return __awaiter(this, void 0, void 0, function () {
      var state;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , contract.getState()];

          case 1:
            state = _a.sent();
            return [2
            /*return*/
            , state && state[field]];
        }
      });
    });
  };

  default_1.prototype.getResolverRecordsStructure = function (resolverAddress) {
    return __awaiter(this, void 0, void 0, function () {
      var resolver, resolverRecords;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (resolverAddress == NullAddress) {
              return [2
              /*return*/
              , {}];
            }

            resolver = this.zilliqa.contracts.at(crypto_1.toChecksumAddress(resolverAddress));
            return [4
            /*yield*/
            , this.getContractField(resolver, 'records')];

          case 1:
            resolverRecords = _a.sent();
            return [2
            /*return*/
            , lodash_1.default.transform(resolverRecords, function (result, value, key) {
              return lodash_1.default.set(result, key, value);
            }, {})];
        }
      });
    });
  };

  default_1.prototype.resolve = function (domain) {
    return __awaiter(this, void 0, void 0, function () {
      var nodeHash, registryRecords, registryRecord, _a, ownerAddress, resolverAddress, resolution, addresses;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            nodeHash = namehash_1.default(domain);
            return [4
            /*yield*/
            , this.getContractField(this.registry, 'records')];

          case 1:
            registryRecords = _b.sent();
            if (!registryRecords) return [2
            /*return*/
            , null];
            registryRecord = registryRecords[nodeHash];
            if (!registryRecord) return [2
            /*return*/
            , null];
            _a = registryRecord.arguments, ownerAddress = _a[0], resolverAddress = _a[1];
            return [4
            /*yield*/
            , this.getResolverRecordsStructure(resolverAddress)];

          case 2:
            resolution = _b.sent();
            addresses = lodash_1.default.mapValues(resolution.crypto, 'address');
            return [2
            /*return*/
            , {
              addresses: addresses,
              meta: {
                owner: ownerAddress || null,
                type: 'zns',
                ttl: parseInt(resolution.ttl) || 0
              }
            }];
        }
      });
    });
  };

  return default_1;
}();

exports.default = default_1;